export default __webpack_public_path__ + "static/media/icon-play.7a12440a.svg";